import React from 'react';


class MenuMobile extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        display: true,
        link: ["#about", "#services", "#contact"]
      }
      this.toggleDisplay = this.toggleDisplay.bind(this);
    }
    toggleDisplay() {
      this.setState({
        display: !this.state.display
      });
    }
    render() {
  if(this.state.display){
      return (
         <div>
           <nav id="toggle">
                 <label id="slidebar" onClick={this.toggleDisplay}>&#9776;</label>
                <h2>Jasnel JUILLET</h2>	<hr></hr>	 
 	        </nav>
         </div>
      );
  }
  else{
     return (
         <div>
           <span className="fa fa-times" id="slidebar" onClick={this.toggleDisplay}></span>
           <div className="menumobile" onClick={this.toggleDisplay}>              
                 <li><a href={this.state.link[2]}>Contact</a></li>               
                 <li><a href={this.state.link[1]}>Services</a></li>
                 <li><a href={this.state.link[0]}>About</a></li>
            </div>
         </div>
      );
  }
    
    }
  };

 export default MenuMobile;